import { defineMessages } from 'react-intl';

export default defineMessages({
  approximate: 'Approximate tx cost',
});
